import type { CustomCellRendererProps } from "@/ui/molecules/Grid";

import type { FileExtractionInfo, ExtractionType } from "../dealTypes";

import Box from "@/ui/atoms/Box";
import { Pill } from "@proda-ai/ui-kit";
export const testIds = {
    rowType: "RowTypeCellRenderer-rowType",
};

type ExtendedCellRendererProps<FileExtractionInfo> =
    CustomCellRendererProps<FileExtractionInfo>;

const formatRowType = (rowType: ExtractionType) => {
    switch (rowType) {
        case "operating_statement_monthly_budget":
            return "Budget";
        case "rent_roll_extraction":
            return "Rent Roll";
        case "operating_statement_monthly_actual":
            return "Trailing Statement";
        case "operating_statement_yearly_actual":
            return "Trailing Statement";
        case "operating_statement_yearly_budget":
            return "Budget";
        case "year_to_date":
            return "Year to Date";
        case "operating_statement_actual_to_budget":
            return "Actual to Budget";
        default:
            return "Other";
    }
};

export const RowTypeCellRenderer: React.FC<
    ExtendedCellRendererProps<FileExtractionInfo>
> = ({ value }) => {
    if (value == null) return;

    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
                width: "fit-content",
            }}
        >
            <Pill
                data-testid={testIds.rowType}
                borderColor="proda-purple"
                backgroundColor={"proda-white"}
                label={formatRowType(value as ExtractionType)}
            />
        </Box>
    );
};
